import React, { useState } from 'react';
import './HomePage.css';
import { Link } from 'react-router-dom';
import EventsDisplay from '../components/EventsDisplay';
import useCustomAlert from '../hooks/useCustomAlert';

const API_URL = process.env.REACT_APP_API_URL || 'https://www.barcodepapel.pt:5017/api';

const modalStyles = `
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.modal-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 2rem;
  z-index: 10001;
  transition: opacity 0.3s;
}

.modal-close-btn:hover {
  opacity: 0.7;
}

.modal-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 3rem;
  z-index: 10001;
  transition: opacity 0.3s;
  padding: 1rem;
}

.modal-nav-btn:hover {
  opacity: 0.7;
}

.modal-nav-btn.prev {
  left: 1rem;
}

.modal-nav-btn.next {
  right: 1rem;
}

.modal-image-container {
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: default;
}

.modal-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
}

.modal-caption {
  color: white;
  margin-top: 1rem;
  text-align: center;
  font-size: 1.125rem;
}

.gallery-image-wrapper {
  cursor: pointer;
  transition: transform 0.3s;
}

.gallery-image-wrapper:hover {
  transform: scale(1.05);
}

.gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Estilos da nova estrutura */
.homepage-services-section {
  padding: 5rem 0;
  background-color: white;
}

.homepage-section-title {
  font-size: 2.5rem;
  color: #5A9C9C;
  text-align: center;
  margin-bottom: 3rem;
  font-weight: 300;
}

.homepage-servicos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
}

.homepage-servico-card {
  background-color: white;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.homepage-servico-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.homepage-servico-image {
  width: 100%;
  height: 250px;
  overflow: hidden;
  background-color: #f3f4f6;
}

.homepage-servico-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.homepage-servico-content {
  padding: 2rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.homepage-servico-content h3 {
  font-size: 1.5rem;
  color: #4A8080;
  margin-bottom: 1rem;
}

.homepage-servico-description {
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 1rem;
  flex: 1;
}

.homepage-servico-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.homepage-servico-duracao,
.homepage-servico-preco {
  color: #4b5563;
  font-size: 0.95rem;
}

.homepage-servico-preco {
  font-size: 1.5rem;
  color: #5A9C9C;
  font-weight: 600;
}

.homepage-servico-btn {
  width: 100%;
  padding: 1rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  text-decoration: none;
  text-align: center;
  display: inline-block;
}

.homepage-servico-btn:hover {
  background-color: #3A6666;
}

@media (max-width: 768px) {
  .homepage-section-title {
    font-size: 2rem;
  }
  
  .homepage-servicos-grid {
    grid-template-columns: 1fr;
    padding: 0 1rem;
  }
}
`;

function ImageModal({ isOpen, onClose, images, currentIndex, onNext, onPrev }) {
  if (!isOpen) return null;

  return (
    <div className="image-modal" onClick={onClose}>
      <button onClick={onClose} className="modal-close-btn">Ã—</button>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        className="modal-nav-btn prev"
      >
        â€¹
      </button>

      <div className="modal-image-container" onClick={(e) => e.stopPropagation()}>
        <img
          src={images[currentIndex].src}
          alt={images[currentIndex].alt}
          className="modal-image"
        />
        {images[currentIndex].caption && (
          <p className="modal-caption">{images[currentIndex].caption}</p>
        )}
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        className="modal-nav-btn next"
      >
        â€º
      </button>
    </div>
  );
}

export default function Home() {
  const { showAlert } = useCustomAlert();
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    assunto: '',
    mensagem: ''
  });

  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isSubmittingContact, setIsSubmittingContact] = useState(false);
  const [isSubmittingNewsletter, setIsSubmittingNewsletter] = useState(false);

  const servicos = [
    {
      id: 1,
      nome: 'Brincoteca - Hora da brincadeira',
      descricao: 'Deixe os seus filhos terem experiências com liberdade total para brincarem e aprenderem com muita imaginação.',
      duracao: '1 h',
      preco: '5 €',
      imagem: '/assets/image5.png',
      detalhes: {
        titulo: 'Brincoteca - Hora da brincadeira',
        preco: '5 €',
        duracao: '1 hora',
        descricao: 'Filipa Ferreira',
      }
    },
    {
      id: 2,
      nome: 'Festa de aniversário',
      descricao: 'Vem comemorar/ conhecer a tua festa de aniversário e traz os teus amigos! Proporcionamos festas únicas e memoráveis.',
      duracao: '2 h 30 min',
      preco: '18 € por participante',
      imagem: '/assets/image6.png',
      detalhes: {
        titulo: 'Festa de aniversário',
        preco: '18 €',
        precoPorParticipante: 18,
        duracao: '2 horas e 30 minutos',
        descricao: 'Filipa Ferreira',
        participantesObrigatorio: true
      }
    }
  ];

  const images = [
    {
      src: '/assets/image1.png',
      alt: 'Criança com trabalho de arte',
      caption: 'Aula de arte'
    },
    {
      src: '/assets/image2.png',
      alt: 'Crianças desenhando',
      caption: 'Aula de arte'
    },
    {
      src: '/assets/image3.png',
      alt: 'Criança pintando',
      caption: 'Aula de arte'
    },
    {
      src: '/assets/image4.png',
      alt: 'Atividades criativas',
      caption: 'Aula de arte'
    }
  ];

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  React.useEffect(() => {
    if (!modalOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [modalOpen]);

  const handleFormChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (isSubmittingContact) return;

    // Validação básica
    if (!formData.nome.trim()) {
      showAlert('Por favor, insira o seu nome', 'error');
      return;
    }

    if (!formData.email.trim()) {
      showAlert('Por favor, insira o seu email', 'error');
      return;
    }

    // Validação de email simples
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      showAlert('Por favor, insira um email válido', 'error');
      return;
    }

    setIsSubmittingContact(true);

    try {
      const response = await fetch(`https://www.barcodepapel.pt:5017/api/contact/send-message`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        showAlert(data.message || 'Mensagem enviada com sucesso! Entraremos em contacto em breve.', 'success');
        // Limpar formulário
        setFormData({
          nome: '',
          email: '',
          assunto: '',
          mensagem: ''
        });
      } else {
        showAlert(data.message || 'Erro ao enviar mensagem. Por favor, tente novamente.', 'error');
      }
    } catch (error) {
      console.error('Erro ao enviar mensagem:', error);
      showAlert('Erro ao enviar mensagem. Por favor, verifique a sua conexão e tente novamente.', 'error');
    } finally {
      setIsSubmittingContact(false);
    }
  };

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();

    if (isSubmittingNewsletter) return;

    if (!newsletterEmail.trim()) {
      showAlert('Por favor, insira o seu email', 'error');
      return;
    }

    // Validação de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newsletterEmail)) {
      showAlert('Por favor, insira um email válido', 'error');
      return;
    }

    setIsSubmittingNewsletter(true);

    try {
      const response = await fetch(`${API_URL}/contact/newsletter-subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: newsletterEmail })
      });

      const data = await response.json();

      if (response.ok) {
        showAlert(data.message || 'Subscrição realizada com sucesso!', 'success');
        setNewsletterEmail('');
      } else {
        showAlert(data.message || 'Erro ao processar subscrição. Por favor, tente novamente.', 'error');
      }
    } catch (error) {
      console.error('Erro ao subscrever newsletter:', error);
      showAlert('Erro ao processar subscrição. Por favor, verifique a sua conexão e tente novamente.', 'error');
    } finally {
      setIsSubmittingNewsletter(false);
    }
  };

  return (
    <>
      <style>{modalStyles}</style>

      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h2 className="hero-title">BARCO DE PAPEL</h2>
            <h3 className="hero-subtitle">ACADEMIA DE CRIATIVIDADE</h3>
            <div className="hero-list">
              <p>Atividades regulares e programadas durante a semana</p>
              <p>Workshops</p>
              <p>Atividades de férias escolares</p>
              <p>Festas de aniversário</p>
            </div>
          </div>

          <div className="image-gallery">
            {images.slice(0, 3).map((image, index) => (
              <div
                key={index}
                className="image-placeholder gallery-image-wrapper"
                onClick={() => openModal(index)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="gallery-image"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="events-display-container">
        <EventsDisplay showTitle={true} limit={3} />
      </div>

      <section className="homepage-services-section">
        <h2 className="homepage-section-title">Nossos serviços</h2>

        <div className="homepage-servicos-grid">
          {servicos.map((servico) => (
            <div key={servico.id} className="homepage-servico-card">
              <div className="homepage-servico-image">
                <img src={servico.imagem} alt={servico.nome} />
              </div>
              <div className="homepage-servico-content">
                <h3>{servico.nome}</h3>
                <p className="homepage-servico-description">{servico.descricao}</p>
                <div className="homepage-servico-info">
                  <p className="homepage-servico-duracao">Duração: {servico.duracao}</p>
                  <p className="homepage-servico-preco">{servico.preco}</p>
                </div>
                <Link
                  className="homepage-servico-btn"
                  to="/booking-calendar"
                  state={{ selectedServico: servico }}
                >
                  Solicitar agendamento
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>



      {/* AULAS DE PILATES E DESENHO - COM AGENDAMENTO */}
      <section className="homepage-info-section">
        <h2 className="homepage-section-title">Outras Atividades</h2>

        <div className="homepage-info-grid">
          {/* Pilates */}
          <div className="homepage-info-card">
            <div className="homepage-info-image">
              <img src="/assets/pilates.png" alt="Aulas de Pilates" />
            </div>
            <div className="homepage-info-content">
              <h3>Aulas de Pilates</h3>
              <p className="homepage-info-description">
                Aulas de pilates para adultos, focadas em fortalecimento, flexibilidade e bem-estar.
                Venha relaxar e cuidar de si!
              </p>
              <div className="homepage-info-details">
                <div className="info-detail-item">
                  <span className="info-label">Horário:</span>
                  <span className="info-value">Todas as Terças-Feiras - das 18h30 às 19h30</span>
                </div>
                <div className="info-detail-item">
                  <span className="info-label">Preço:</span>
                  <span className="info-value">5€ por sessão</span>
                </div>
                <div className="info-detail-item">
                  <span className="info-label">Contacto:</span>
                  <span className="info-value">Para mais informações, contacte-nos</span>
                </div>
              </div>
              <Link
                className="homepage-servico-btn"
                to="/booking-calendar"
                state={{
                  selectedServico: {
                    id: 'pilates',
                    nome: 'Aulas de Pilates',
                    descricao: 'Aulas de pilates para adultos',
                    duracao: '1 h',
                    imagem: '/assets/pilates.png',
                    detalhes: {
                      titulo: 'Aulas de Pilates',
                      duracao: '1 hora',
                      descricao: 'Terças-feiras',
                      tipo: 'Pilates',
                      diaSemana: 2,
                      semPagamento: true
                    }
                  }
                }}
              >
                Solicitar agendamento
              </Link>
            </div>
          </div>

          {/* Desenho */}
          <div className="homepage-info-card">
            <div className="homepage-info-image">
              <img src="/assets/desenho.png" alt="Aulas de Desenho" />
            </div>
            <div className="homepage-info-content">
              <h3>Aulas de Desenho e Pintura</h3>
              <p className="homepage-info-description">
                Desenvolva a criatividade artística dos seus filhos através de técnicas de desenho e pintura.
              </p>
              <div className="homepage-info-details">
                <div className="info-detail-item">
                  <span className="info-label">Horário:</span>
                  <span className="info-value">Todas as Quartas-Feiras - das 18h30 às 19h30</span>
                </div>
                <div className="info-detail-item">
                  <span className="info-label">Contacto:</span>
                  <span className="info-value">Para mais informações, contacte-nos</span>
                </div>
              </div>
              <Link
                className="homepage-servico-btn"
                to="/booking-calendar"
                state={{
                  selectedServico: {
                    id: 'desenho',
                    nome: 'Aulas de Desenho e Pintura',
                    descricao: 'Aulas de desenho para crianças',
                    duracao: '1 h',
                    imagem: '/assets/desenho.png',
                    detalhes: {
                      titulo: 'Aulas de Desenho e Pintura',
                      duracao: '1 hora',
                      descricao: 'Quartas-feiras',
                      tipo: 'Desenho',
                      diaSemana: 3,
                      semPagamento: true
                    }
                  }
                }}
              >
                Solicitar agendamento
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-section">
        <div className="contact-container">
          <form onSubmit={handleFormSubmit} className="contact-form">
            <div className="form-group">
              <label>Nome *</label>
              <input
                type="text"
                name="nome"
                value={formData.nome}
                onChange={handleFormChange}
                placeholder="Insira seu nome"
                required
                disabled={isSubmittingContact}
              />
            </div>

            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleFormChange}
                placeholder="Insira seu email"
                required
                disabled={isSubmittingContact}
              />
            </div>

            <div className="form-group">
              <label>Assunto</label>
              <input
                type="text"
                name="assunto"
                value={formData.assunto}
                onChange={handleFormChange}
                placeholder="Insira o assunto"
                disabled={isSubmittingContact}
              />
            </div>

            <div className="form-group">
              <label>Mensagem</label>
              <textarea
                name="mensagem"
                value={formData.mensagem}
                onChange={handleFormChange}
                placeholder="Digite sua mensagem aqui"
                rows="6"
                disabled={isSubmittingContact}
              />
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmittingContact}
              style={{
                opacity: isSubmittingContact ? 0.6 : 1,
                cursor: isSubmittingContact ? 'not-allowed' : 'pointer'
              }}
            >
              {isSubmittingContact ? 'Enviando...' : 'Enviar'}
            </button>
          </form>
        </div>
      </section>

      <section className="map-section">
        <div className="map-container-wrapper">
          <div className="map-info">
            <p className="map-title">📍Barco de Papel</p>
            <p className="map-address">Barco de Papel - Academia de Criatividade</p>
            <p className="map-address">R. 31 janeiro, 12 4490-511 Póvoa de Varzim</p>
            <div className="map-links">
              <a
                href="https://www.barcodepapel.pt/"
                target="_blank"
                rel="noopener noreferrer"
                className="map-link"
              >
                Link
              </a>
              <a
                href="https://www.google.com/maps/dir//R.+31+janeiro+12+4490-511+Póvoa+de+Varzim"
                target="_blank"
                rel="noopener noreferrer"
                className="map-link"
              >
                Direções
              </a>
            </div>
          </div>
          <div className="map-iframe-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3004.8087847477896!2d-8.764893!3d41.383333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd2464e3ed7b0001%3A0x8a7b0d0d0d0d0d0d!2sR.%2031%20de%20Janeiro%2012%2C%204490-511%20P%C3%B3voa%20de%20Varzim!5e0!3m2!1sen!2spt!4v1234567890"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Barco de Papel"
            />
          </div>
        </div>
      </section>

      <section className="newsletter-section">
        <div className="newsletter-container">
          <h3 className="newsletter-title">Subscreva a nossa newsletter</h3>
          <form onSubmit={handleNewsletterSubmit} className="newsletter-form">
            <input
              type="email"
              placeholder="e.g., email@example.com"
              value={newsletterEmail}
              onChange={(e) => setNewsletterEmail(e.target.value)}
              required
              className="newsletter-input"
              disabled={isSubmittingNewsletter}
            />
            <button
              type="submit"
              className="newsletter-btn"
              disabled={isSubmittingNewsletter}
              style={{
                opacity: isSubmittingNewsletter ? 0.6 : 1,
                cursor: isSubmittingNewsletter ? 'not-allowed' : 'pointer'
              }}
            >
              {isSubmittingNewsletter ? 'Enviando...' : 'Enviar'}
            </button>
          </form>
        </div>
      </section>

      <ImageModal
        isOpen={modalOpen}
        onClose={closeModal}
        images={images}
        currentIndex={currentImageIndex}
        onNext={nextImage}
        onPrev={prevImage}
      />
    </>
  );
}